import React from "react";
import { FiFileText } from "react-icons/fi";

import styles from "./new.module.css";
import { getSentenceFromCamelCase } from "./Helpers";
import { TextareaProps } from "../../types/form";

type ModernTextareaProps = TextareaProps & {
  leftIcon?: React.ReactNode;
};

const Textarea = ({
  className,
  disabled,
  error,
  required,
  label,
  name,
  onChange,
  placeholder,
  style,
  validationHandler,
  value,
  size = "medium",
  labelClassName,
  leftIcon,
}: ModernTextareaProps) => {
  const onChangeHandler = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    const { name, value } = event.target;

    onChange && onChange(name, value);
  };

  const onValidationChange = (
    event: React.ChangeEvent<HTMLTextAreaElement>,
  ) => {
    if (!validationHandler) return;

    const { value } = event.target;
    let errorMessage = "";

    if (!value && required) {
      errorMessage = `Please enter ${getSentenceFromCamelCase(name)}.`;
    }

    validationHandler(name, errorMessage);
  };

  return (
    <div
      className={`${styles.InputContainer} ${styles[size || ""]} ${
        error ? styles.hasError : ""
      }`}
    >
      <label htmlFor={name} className={labelClassName || styles.inputLabel}>
        {label} {required && <span className={styles.required}>&nbsp;*</span>}
      </label>

      <div className={`${styles.fieldShell} ${styles.textareaShell}`}>
        <span
          className={`${styles.fieldIcon} ${styles.textareaIcon}`}
          aria-hidden="true"
        >
          {leftIcon || <FiFileText />}
        </span>

        <textarea
          id={name}
          name={name}
          value={value as string}
          placeholder={placeholder}
          required={required}
          readOnly={disabled}
          className={`${styles.blackBorder} ${styles.modernInput} ${
            styles.modernTextarea
          } ${className || ""} ${error ? styles.borderRed : ""}`}
          style={style}
          onChange={onChangeHandler}
          onBlur={onValidationChange}
        />
      </div>

      {error ? (
        <span className={`${styles.required} ${styles.textSmall}`}>
          {error}
        </span>
      ) : null}
    </div>
  );
};

export default Textarea;
